import {Nullable} from '../app/TypeHelpers'

export const formatServerTime = (hour: Nullable<string | number>, minute: Nullable<string | number>): string => {
    const zeroPaddedHour: string = `0${hour || '0'}`.substr(-2)
    const zeroPaddedMinute: string = `0${minute || '0'}`.substr(-2)
    return `${zeroPaddedHour}:${zeroPaddedMinute}:00`
}
